/** ng serve :4201 — UI do SSO local; API de autenticação em :8000 (desenvolvimento do projeto SSO). */
export const environment = {
  production: false,
  urlBaseApiCliente: 'http://localhost:8000',
  sso: {
    urlBaseServicoSSO: 'http://localhost:4201',
    pathLogin: '/login/',
    pathLogout: '/auth/logout/',
    redirectUriPosLogout: 'http://localhost:4201/login',
  },
  refreshToken: {
    url: 'http://localhost:8000/token/refresh/',
    intervaloSolicitacoes: 1_500_000,
  },
  captchaKey: '1x00000000000000000000AA',
};
